import script from "./Flex.vue?vue&type=script&lang=ts&setup=true"
export * from "./Flex.vue?vue&type=script&lang=ts&setup=true"

import "./Flex.vue?vue&type=style&index=0&id=2d97740a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d97740a"]])

export default __exports__